import { PhantomSkeleton, type SkeletonKind } from '@/shared/ui/ui-skeleton'
import UiSpin from '@/shared/ui/ui-spin'
import type React from 'react'
import './PageLoading.scss'

/** public = màn chưa đăng nhập (spinner AntD) · private = màn sau đăng nhập (PhantomSkeleton). */
export type PageLoadingVariant = 'public' | 'private'

export interface PageLoadingProps {
  variant: PageLoadingVariant
  fullscreen?: boolean
  tip?: string
  /** Hình khung giả của variant 'private'. Mặc định 'table'. */
  skeletonKind?: SkeletonKind
}

export const SkeletonPageLoading = ({ kind = 'table' }: { kind?: SkeletonKind }) => (
  <div className="vbdt-page-loading__skeleton">
    <div className="vbdt-page-loading__skeleton-card">
      <PhantomSkeleton kind={kind} />
    </div>
  </div>
)

export const SpinnerLoading = ({ tip }: { tip?: string }) => (
  <div className="vbdt-page-loading__spinner">
    <UiSpin size="large" tip={tip} />
  </div>
)

export const PageLoading: React.FC<PageLoadingProps> = ({
  variant,
  fullscreen = false,
  tip,
  skeletonKind,
}) => (
  <div className={`vbdt-page-loading ${fullscreen ? 'vbdt-page-loading--fullscreen' : ''}`}>
    {variant === 'public' ? (
      <SpinnerLoading tip={tip} />
    ) : (
      <SkeletonPageLoading kind={skeletonKind} />
    )}
  </div>
)

export default PageLoading
